<template>
    <Card pageTitle="Cash Management">
        <AllowPermission :permission="PERMISSION_CODES.CMS_VIEW_CASH_MANAGEMENT">
            <div>
                <CustomTable>
                    <template #head>
                        <tr>
                            <th>Name</th>
                            <th>Cash Management</th>
                            <th>Status</th>
                            <th>Total On Premises</th>
                            <th>Actions</th>
                        </tr>
                    </template>
                    <template #body>
                        <tr v-for="safe of safes" :key="safe.id">
                            <td>
                                <router-link :to="`/cash-management/${safe.id}`" class="text-primary">{{ safe.name }}</router-link>
                            </td>
                            <td>{{ safe.cashManagementEnabled ? "Enabled" : "Disabled" }}</td>
                            <td>
                                <div :class="[{ 'fail-chip': !safe.isOpen }, { 'success-chip': safe.isOpen }]">
                                    {{ safe.isOpen ? "Open" : "Closed" }}
                                </div>
                            </td>
                            <td>
                                <div :title="`Safe: $${safe.safeOnHandCash || 0} | Drawers: $${safe.drawersOnHandCash || 0}`">
                                    ${{ round2(safe.totalOnPremisesCash || 0) }}
                                </div>
                            </td>
                            <td>
                                <router-link :to="`/cash-management/${safe.id}`" class="text-primary"> View Safe </router-link>
                            </td>
                        </tr>
                    </template>
                </CustomTable>
            </div>
        </AllowPermission>
    </Card>
</template>

<script>
import CrudIndex from "../../components/crud/index.vue"
import { createField, createColumn, round2 } from "../../utils/common"
import { http } from "@/utils/http"
import Paginator from "../../components/other/Paginator.vue"
import Card from "../../components/UI/Card.vue"
import CashManagementFetchApi from "@/utils/fetch/cash-management-fetch-api"
import CustomTable from "../../components/layout/CustomTable.vue"
import Button from "../../components/UI/Button.vue"
import AllowPermission from "../../components/layout/AllowPermission.vue"
import { PERMISSION_CODES } from "../../store/permission"

export default {
    data() {
        return {
            safes: [],
            PERMISSION_CODES,
        }
    },
    components: { Button, Card, CrudIndex, Paginator, CustomTable, AllowPermission },
    async mounted() {
        this.safes = await CashManagementFetchApi.fetchSafeOrDrawers()
    },
    methods: { round2 },
}
</script>

<style lang="scss" scoped>
@import "../../assets/variables.scss";

.notification-item {
    padding: 10px;
    margin-bottom: 10px;
    border-radius: 5px;
    font-size: 0.9em;
    border: 1px solid $lightBorderColor;
    background-color: $lightCardBg;
    &.unread {
        background-color: lighten($lightCardBg, 2%);
        border: 1px solid lighten($lightBorderColor, 5%);
    }
}
.success-chip,
.fail-chip {
    padding: 2px 8px;
    border-radius: $component-border-radius;
    font-size: 12px;
    text-align: center;
    min-width: 70px;
    background-color: $lightHoverColor;
    border: 1px solid $lightBorderColor;
}
.success-chip { color: #fff; background-color: #28a745; border-color: #28a745; }
.fail-chip { color: #fff; background-color: #6c757d; border-color: #6c757d; }

/* Dark mode overrides */
:deep(.dark) {
    .fail-chip {
        background-color: #6c757d;
        color: white;
    }
    
    .success-chip {
        background-color: #28a745;
        color: white;
    }
}
</style>
